import React, { useCallback } from 'react';
import { Backdrop, Box, Modal, Fade, SxProps, Theme } from '@mui/material';
import CloseIcon from '../../../assets/icons/close.svg?react';
import ButtonUI from '../Button/Button';
import { modalStyle } from './style';

interface ModalUIProps {
  className?: string;
  open: boolean;
  closeAfterTransition?: boolean | undefined;
  disableEscapeKeyDown?: boolean | undefined;
  keepMounted?: boolean | undefined;
  children: React.ReactNode;
  backdropTimeout?: number;
  modalTitle?: string;
  isCloseBtn?: boolean;
  onCloseHandler?: ((event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void) | undefined;
  modalSx?: SxProps<Theme>;
  hideBackDrop?: boolean;
  modalRef?: React.RefObject<HTMLDivElement> | null | undefined;
}

export const ModalUI = (props: ModalUIProps) => {
  const {
    className,
    open,
    onCloseHandler,
    closeAfterTransition = true,
    disableEscapeKeyDown = false,
    keepMounted = false,
    children,
    backdropTimeout = 500,
    isCloseBtn = false,
    modalSx,
    hideBackDrop = false,
    modalRef,
  } = props;

  const { modal } = modalStyle;

  const onClose = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
      if (onCloseHandler) onCloseHandler(event, 'backdropClick');
    },
    [onCloseHandler]
  );

  return (
    <Modal
      sx={{ ...modal, ...modalSx } as SxProps<Theme>}
      className={className}
      open={open}
      hideBackdrop={hideBackDrop}
      onClose={onCloseHandler}
      closeAfterTransition={closeAfterTransition}
      disableEscapeKeyDown={disableEscapeKeyDown}
      keepMounted={keepMounted}
      slots={{ backdrop: Backdrop }}
      ref={modalRef}
      slotProps={{
        backdrop: {
          timeout: backdropTimeout,
        },
      }}
    >
      <Fade in={open}>
        <Box className="modal-wrapper">
          {isCloseBtn && <ButtonUI icon={<CloseIcon />} className="close-btn" size="small" onClickHandler={onClose} />}
          {children}
        </Box>
      </Fade>
    </Modal>
  );
};
